import http from '@services/http'
import { IBettor, IBettorFind } from '@protocol/bettor'
import { Schema$BettorBetRecord } from '@protocol/my'

export default {
  // ------- 유저의 메시지를 관리하는 부분 (클럽메시지) -------
  fetchBettors(data: IBettorFind.Params): Promise<IBettorFind.Schema> {
    return http.get('bettor/list', data || {})
  },
  // 채팅 메세지 전달용 (사용안함)
  doSendMessage(data: IBettor.SendMessageParams): Promise<IBettor.successSchema> {
    return http.post('bettor/do_send_message', data || {})
  },

  getBettorBetRecord(params: IBettor.BettorBetRecordParams): Promise<Schema$BettorBetRecord> {
    return http.get('bettor/bettorBetRecord', params || {})
  }
}
